<template>
    <tailwind-layout title="Application to Rent">
        <template #header>
            <h2 class="text-xl font-bold leading-7 sm:text-3xl sm:truncate text-center">
                Application to Rent {{ property.full_address }}
            </h2>
        </template>

        <div class="bg-rent-risk-blue-100 overflow-hidden sm:rounded-lg">
            <div class="relative max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8 text-center">
                <h4 class="text-3xl font-bold leading-7 text-gray-700 sm:text-2xl sm:truncate">
                    One Time Passcode
                </h4>
                <form @submit.prevent="store" class="space-y-8 divide-y divide-gray-200 text-center">
                    <div class="space-y-8">
                        <div class="mt-6 grid grid-cols-6 gap-y-6 gap-x-4 sm:grid-cols-6">
                            <div class="sm:col-span-6 mx-auto">
                                <input type="text" v-model="form.otp" class="text-5xl text-center max-w-lg block w-full shadow-sm focus:ring-rent-risk-blue-400 focus:border-rent-risk-blue-400 sm:max-w-xs border-gray-300 rounded-md">
                            </div>
                        </div>
                    </div>
                    <div class="pt-5 grid grid-cols-6 gap-4">
                        <div class="col-end-7 col-span-2 justify-end flex">
                            <inertia-link :href="route('application.steps',application.id)" class="bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-rent-risk-blue-400">Cancel</inertia-link>
                            <form-button :form="form" type="submit">
                                Save
                            </form-button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </tailwind-layout>
</template>

<script>
import Icon from '@/Shared/Icon.vue'
import TailwindLayout from '@/Layouts/TailwindLayout.vue'
import FormButton from '@/Shared/FormButton.vue'
import LoadingButton from '@/Shared/LoadingButton.vue'
import SelectInput from "@/Shared/SelectInput.vue"

export default {
    components: {
        Icon,
        TailwindLayout,
        FormButton,
        LoadingButton,
        SelectInput,
    },
    props: {
        property: Object,
        application: Object,
    },
    remember: 'form',
    data() {
        return {
            form: this.$inertia.form({
                otp: '',
            }),
            property: this.property,
            application: this.application,
        }
    },
    methods: {
        store() {
            this.form.post(this.route('application.otp.submit', this.application.id))
        },
    }
}
</script>
